import { Canvas } from '@react-three/fiber';
import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import VideoPanoramaViewer from '../components/VideoPanoramaViewer';
import LogoModal from '../components/LogoModal';
import { handleFullScreen } from '../utils/handleFullScreenMode';
import BellIcon from '../components/BellIcon';

const ParkPanorama = () => {
    const [isOverlayVisible, setOverlayVisible] = useState(false);
    const [isAudioPaused, setAudioPaused] = useState(true);
    const navigate = useNavigate();
    const audioRef = useRef(null);
    const pageRef = useRef();
    const [isNavShowing, setIsNavShowing] = useState(false)
    // Toggle overlay visibility
    const handleToggleOverlay = () => {
        setOverlayVisible(prev => !prev);

        // If opening overlay, start audio
        if (!isOverlayVisible) {
            audioRef.current.play();
            setAudioPaused(false);
        } else {
            audioRef.current.pause();
            setAudioPaused(true);
        }
    };

    // Play audio
    const handlePlay = () => {
        audioRef?.current.play();
        setAudioPaused(false);
    };

    // Pause audio
    const handlePause = () => {
        audioRef?.current.pause();
        setAudioPaused(true);
    };

    // Close overlay & stop audio
    const handleCloseOverlay = () => {
        setOverlayVisible(false);
        audioRef?.current.pause();
        audioRef.current.currentTime = 0; // Reset audio
        setAudioPaused(true);
    };

    return (
        <div className="w-full h-screen relative" ref={pageRef}>
            <LogoModal
                isNavShowing={isNavShowing}
                setIsNavShowing={setIsNavShowing}
                audio='/360-Lernwelt/extras/audios/bg-audio-park-panorama.mp3'
                handleFullScreen={() => handleFullScreen(pageRef)} />
            <Canvas>
                {/* <VideoPanoramaViewer videoSrc='https://rakuns.de/_assets/vid/VR_Fahrradfahren_blurred/master.m3u8' /> */}
                <VideoPanoramaViewer videoSrc='https://rakuns.de/_assets/vid/VR_Fahrradfahren_blurred/master.m3u8' />
            </Canvas>


            <div className='absolute top-0 left-0 z-50 flex gap-4 items-center'>
                <button
                    className='bg-blue-500 text-white p-2 rounded-md m-4 text-3xl hover:bg-blue-600'
                    onClick={() => navigate(-1)}
                >
                    Zurück
                </button>

                <BellIcon handleToggleOverlay={handleToggleOverlay} />
            </div>

            {isOverlayVisible && (
                <div className="absolute bottom-0 left-0 w-full bg-black/55 p-4 h-screen pb-16   z-40 flex flex-col">
                    <audio src='/360-Lernwelt/extras/audios/bell-ring.mp3' autoPlay className='hidden' />

                    <div className="w-[450px] mx-auto  tracking-wide bg-white p-4 rounded-xl absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                        <div className='flex w-full justify-end gap-2 rounded-xl shadow-lg overflow-hidden mb-4'>
                            {isAudioPaused ? (
                                <img src="/360-Lernwelt/extras/play.gif" alt="Play" className='size-10 cursor-pointer' onClick={handlePlay} />
                            ) : (
                                <img src="/360-Lernwelt/extras/pause.gif" alt="Pause" className='size-10 cursor-pointer' onClick={handlePause} />
                            )}
                            <img src="/360-Lernwelt/extras/cross.gif" alt="Close" className='size-10 cursor-pointer' onClick={handleCloseOverlay} />
                        </div>
                        <p className='font-mullish'>
                            Während wir hier so gemütlich durch den Park radeln, fällt euch bestimmt die frische Luft auf, oder? Das ist kein Zufall! Wisst ihr, Autos brauchen Benzin zum Fahren und Stoßen dabei Abgase aus, die unsere Luft verschmutzen. Das ist schlecht für uns und die Natur. Fahrräder sind da ganz anders! Wir brauchen nur unsere eigene Energie und pusten keine schädlichen Abgase in die Luft. Wenn wir also öfter Fahrrad fahren, schützen wir die Luft und halten sie sauber. Und ganz nebenbei macht Fahrradfahren auch noch richtig viel Spaß, findet ihr nicht?
                        </p>
                    </div>
                </div>
            )}

            {/* Audio Element */}
            <audio ref={audioRef} src="/360-Lernwelt/extras/audios/park-panorma-audio.mp3"
                onEnded={handleCloseOverlay}
            />
        </div>
    );
};
export default ParkPanorama;
